import { Directive, EventEmitter, HostListener, Input, Output } from "@angular/core";

// to use : <div watchSizeRotate (onSizeRotateChanged)="handler()"></div>

@Directive({
  selector: '[watchSizeRotate]',
  standalone: true,
})
export class WatchSizeRotateDirective {

  @Input() watchSizeRotate: string;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.onChange('size');
  }
  @HostListener('window:orientationchange', ['$event'])
  onRotate(event: Event) {
    this.onChange('rotate');
  }

  @Output() onSizeRotateChanged = new EventEmitter<void>(true);

  constructor() {
  }

  onChange(type) {
    const watchSizeRotateType = this.watchSizeRotate;
    if (!watchSizeRotateType || type === watchSizeRotateType) {
      this.onSizeRotateChanged.emit();
    }
  }
}